// extracted by mini-css-extract-plugin
module.exports = {"inner":"BurgerContent-module--inner--lFVbF","root":"BurgerContent-module--root--CrPgT","active":"BurgerContent-module--active--1S49N"};